import { useAppContext } from "@src/autoDebit/AppContext";
import message from "@src/autoDebit/message";
import styles from "./stepsFlow.module.css";

interface IStepsFlow {
  theme?: "success";
}

const StepsFlow = ({ theme }: IStepsFlow) => {
  const { intl } = useAppContext();
  return (
    <div className={theme ? styles[theme] : ""}>
      <ul className={styles.bar}>
        <li className={`${styles.step} ${theme ? "" : styles.stepActive}`}>
          {theme ? <a className={styles.number}>Step.1</a> : null}
          <a className={styles.note}>{intl.formatMessage(message.Step1)}</a>
        </li>
        <li className={styles.step}>
          <a className={styles.number}>Step.2</a>
          <a className={styles.note}>{intl.formatMessage(message.Step2)}</a>
        </li>
        <li className={styles.step}>
          <a className={styles.number}>Step.3</a>
          <a className={styles.note}>{intl.formatMessage(message.Step3)}</a>
        </li>
        <li className={`${styles.step} ${theme ? styles.stepActive : ""}`}>
          {!theme ? <a className={styles.number}>Step.4</a> : null}
          <a className={styles.note}>{intl.formatMessage(message.Step4)}</a>
          <p className={styles.descriptionMobile}>
            {intl.formatMessage(message.StepTip)}
          </p>
        </li>
      </ul>
      <p className={styles.descriptionDesk}>
        {intl.formatMessage(message.StepTip)}
      </p>
    </div>
  );
};

export default StepsFlow;
